import { InputAdornment } from "@mui/material";
import { TextField } from "components/TextField";
import React from "react";

export const VALUE_ERROR =
  "You must enter a valid number value for numerical type attributes";

const validateNumericValue = (value: string): string | undefined => {
  if (!value || value.length === 0) {
    return VALUE_ERROR;
  }

  return undefined;
};

export interface AttributeNumericFieldProps {
  value: string;
  onChangeValue: (value: string) => void;
  error: string | undefined;
  onError: (message: string) => void;
  onClearError: () => void;
  enableLabel: boolean;
  size: "small" | "medium";
  dense: boolean;
  placeholder?: string;
  inputAdornment?: React.ReactNode;
}

export const AttributeNumericField = ({
  value,
  onChangeValue,
  error,
  onError,
  onClearError,
  enableLabel,
  size,
  dense,
  placeholder,
  inputAdornment
}: AttributeNumericFieldProps): JSX.Element => {
  const handleAttributeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const errorMessage = validateNumericValue(event.target.value);

    if (errorMessage !== undefined) {
      onError(errorMessage);
    } else {
      onClearError();
    }

    onChangeValue(event.target.value);
  };

  return (
    <TextField
      fullWidth
      type="number"
      size={size ?? "medium"}
      margin={dense ? "dense" : "none"}
      error={Boolean(error)}
      helperText={error}
      label={enableLabel ? "Attribute Value" : ""}
      value={value}
      // This is a workaround for a limitation with mui text fields: https://mui.com/material-ui/react-text-field/#shrink
      InputLabelProps={{ shrink: true }}
      onChange={handleAttributeChange}
      aria-label="meta value input"
      placeholder={placeholder}
      data-qa="CM-Text-Attribute-Value"
      InputProps={{
        endAdornment: inputAdornment ? (
          <InputAdornment position="end">{inputAdornment}</InputAdornment>
        ) : null
      }}
    />
  );
};
